<template>
  <v-system-bar
    v-if="detected"
    app
    color="red lighten-4"
  >
    <div class="flex-grow-1" />
    <v-icon>pan_tool</v-icon>
    <span class="caption">AdBlock detectado. Algumas funções do sistema podem não funcionar corretamente.</span>
  </v-system-bar>
</template>

<script>
import VueAdBlockDetect from 'vue-adblock-detect'
export default {
  name: 'AppSystemBarAdBlock',
  mixins: [VueAdBlockDetect],
  data () {
    return {
      detected: false
    }
  },
  async beforeMount () {
    this.detected = await this.detectAdBlock()
  }
}
</script>
